import { query } from "@/utils/api-utils";
import { request } from ".";
import { AuthParams } from "./account";

export const instagramApi = {
  getConnectLink: (redirect_uri: string, rewrite?: boolean) => request("/instagram/connect"+query({ redirect_uri, rewrite })),
  connectToInstagram: ({ code, state, redirect_uri }: AuthParams) => request("/instagram/connect"+query({ redirect_uri }), { code, state }),
}